var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrymyaiSsBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.895,
    height: 9.894,
    viewBox: "0 0 9.895 9.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -40.194,
    y1: -187.225,
    x2: -41.802,
    y2: -186.601,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 502.642,
    y1: -656.555,
    x2: 501.035,
    y2: -655.931,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -20.791,
    y1: -104.035,
    x2: -20.038,
    y2: -104.291,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28673",
    "data-name": "Group 28673",
    transform: "translate(0.5 0.5)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M719.6,51.62a4.447,4.447,0,0,1-4.447,4.447h0A4.447,4.447,0,0,1,710.7,51.62h0a4.448,4.448,0,0,1,4.447-4.447h0A4.447,4.447,0,0,1,719.6,51.62Z",
    transform: "translate(-710.705 -47.173)",
    fill: "#aed5cf",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526",
    transform: "translate(3.392 2.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M185.069,161.54c-.1-.594-.524-.727-1.118-.632s-1.127.383-1.032.976.27-.037,1.076-.166C184.823,161.585,185.164,162.134,185.069,161.54Z",
    transform: "translate(-182.908 -160.88)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4660",
    "data-name": "Path 4660",
    d: "M3.221.983C3.079.1,2.439-.1,1.554.041S-.125.612.017,1.5s.4-.055,1.6-.248C2.854,1.051,3.362,1.868,3.221.983Z",
    transform: "translate(1.621 1.83) rotate(-11)",
    opacity: 0.627,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4661",
    "data-name": "Path 4661",
    d: "M147.123,230.722c-1.14.24-2.634-.6-2.458.236a1.894,1.894,0,0,0,2.382,1.075c1.139-.24,1.921-1.111,1.745-1.946S148.262,230.482,147.123,230.722Z",
    transform: "translate(-141.164 -224.312)",
    opacity: 0.636,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrymyaiSsBullet);
export default __webpack_public_path__ + "static/media/trymyai-ss-bullet.51a22e660933bd8857344dad45bc3240.svg";
export { ForwardRef as ReactComponent };